import P, { shape } from 'prop-types';
import BoxDataComponent from './BoxDataComponent';

const FrameReasons = ({data}) => 
    (
        <>
            <BoxDataComponent title="Quadro Motivos" data={data}/>
        </>
    )

FrameReasons.propTypes = {
    data: P.arrayOf(
      shape({
        id: P.number,
        value: P.string,
      })
    ),
};
  
FrameReasons.defaultProps = {
    data: null,
};

export default FrameReasons;
